/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The console api url prefix.
 * @export
 */
export const CONSOLE_REST_ADAPTER_API_PREFIX = `/api`;

/**
 * The wait time between polling the API (10 seconds).
 * @export
 */
export const API_POLL_INTERVAL_10 = 10000;

/**
 * The local storage key for the logged in user's DXP service tokens.
 */
export const LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS = 'tokens';
